module.exports = __webpack_public_path__ + "img/mlh-cli.f57bf95.png";